export function pickName(
  obj: { nameZh?: string; nameKm?: string | null; nameEn?: string | null },
  locale: string,
): string {
  if (locale === 'km-KH' && obj.nameKm) return obj.nameKm;
  if (locale === 'en' && obj.nameEn) return obj.nameEn;
  return obj.nameZh ?? '';
}

export function pickTitle(
  obj: { titleZh?: string; titleKm?: string | null; titleEn?: string | null },
  locale: string,
): string {
  if (locale === 'km-KH' && obj.titleKm) return obj.titleKm;
  if (locale === 'en' && obj.titleEn) return obj.titleEn;
  return obj.titleZh ?? '';
}

export function pickContent(
  content: { zh?: string; km?: string; en?: string } | null | undefined,
  locale: string,
): string {
  if (!content) return '';
  if (locale === 'km-KH') return content.km ?? content.zh ?? content.en ?? '';
  if (locale === 'en') return content.en ?? content.zh ?? '';
  return content.zh ?? content.en ?? '';
}

export function pickDescription(
  desc: { zh?: string; km?: string; en?: string } | null | undefined,
  locale: string,
): string | null {
  if (!desc) return null;
  if (locale === 'km-KH') return desc.km ?? desc.zh ?? desc.en ?? null;
  if (locale === 'en') return desc.en ?? desc.zh ?? null;
  return desc.zh ?? null;
}
